/**
 * Returns event props for handling clicks on mobile devices.
 * Uses onTouchStart on mobile to avoid double-tap zoom issues.
 *
 * Use this utility in CLASS components where hooks cannot be used.
 * For FUNCTIONAL components, prefer useMobileClick hook instead.
 *
 * @param {Function} onClick - The click handler function
 * @param {boolean} isMobile - Whether the device is mobile
 * @returns {Object} Event props object with either onClick or onTouchStart
 */
function getTouchProps(onClick, isMobile) {
  if (!isMobile) return { onClick }

  return {
    onTouchStart: (e) => {
      e.preventDefault()
      e.stopPropagation()
      onClick(e)
    },
  }
}

export default getTouchProps
